import axios from 'axios';
import { auth } from '../../../firebase';
import { GLAccount } from '../../Interfaces/Accounting/AccountsPayables.interfaces';

const apiUrl = process.env['NX_API_URL'];

export const fecthGLAccounts = async (
  companyID: string,
  startDigits?: number[],
  signal?: AbortSignal
): Promise<GLAccount[]> => {
  const response = await axios.get(`${apiUrl}/api/glAccounts`, {
    signal,
    params: { companyID, startDigits },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
  });

  return response.data;
};
